/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Arable_Soft_Baboon_TapInputs */

const fr_arable_soft_baboon_tap = /** @type {(inputs: Arable_Soft_Baboon_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refuser`)
};

/**

* @param {Arable_Soft_Baboon_TapInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const arable_soft_baboon_tap = /** @type {((inputs?: Arable_Soft_Baboon_TapInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Arable_Soft_Baboon_TapInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_arable_soft_baboon_tap(inputs)
});